<template>
  <div
    class="match-indicators-container"
    data-match-indicator-container
    data-overlay-prevent-close
    :style="{ width: width + 'px', height: height + 'px' }"
  >
    <ul
      :class="matchIndicatorsClasses"
      data-gtm-match-indicators
      data-match-indicators
      >
      <li
        v-for="(work, index) in works"
        :key="index"
        class="match-indicators__item accent-color--background"
        :style="{top: `${calculateTopOffset(index)}px`, left: `${calculateLeftOffset(index)}px`}"
        >
        <a
          :aria-label="ariaLabelForWork(index)"
          class="match-indicators__indicator-link"
          data-gtm="clicks match icon on image"
          href="#"
          @click.prevent="$emit('onClickIdentifiedWork', index, $event.currentTarget)"
          v-html="matchIndicatorLink"
        />
      </li>
    </ul>
    <div class="match-indicators__toggle__container">
      <a
        class="icon-link--control"
        href="#"
        data-match-indicator-toggle
        :data-gtm="showHideGtmValue"
         @click.prevent="toggleMatchIndicators"
        >
        <span
          class="icon-link--control__text--list"
          v-html="renderToggleNodes"
        />
      </a>
    </div>
  </div>
</template>

<script>
  import { embedSVG } from 'Helpers/embedSVG';

  export default {

    props: {
      works: { type: Array, required: true },
      height: { type: Number, required: true },
      width: { type: Number, required: true },
    },

    data: function() {
      return {
        showingIndicators: true,
      };
    },

    computed: {
      matchIndicatorsClasses() {
        if (this.showingIndicators) {
          return "match-indicators";
        }
        return "match-indicators match-indicators--hidden";
      },

      matchIndicatorLink() {
        return embedSVG("icon__corners--16.svg", "match-indicators__indicator-link__svg");
      },

      showHideGtmValue() {
        if (this.showingIndicators) {
          return "clicks hide icon";
        }
        return "clicks unhide icon";
      },

      renderToggleNodes() {
        return `
          ${embedSVG("icon__corners--16.svg", "icon-link__svg--before")}
          <span class="match-indicators__toggle__wording--hide">Hide</span>
          <span class="match-indicators__toggle__wording--show">Show</span>
        `;
      },

      todo() {
        // for later date, create class that defines work in works array
      }
    },

    methods: {
      toggleMatchIndicators() {
        this.showingIndicators = !this.showingIndicators;
      },

      calculateTopOffset(index) {
        let y = this.height * ((this.works[index].MatchCoordinates.BL.Y + this.works[index].MatchCoordinates.BR.Y) / 2);
        return Math.round(y);
      },

      calculateLeftOffset(index) {
        let x = this.width * ((this.works[index].MatchCoordinates.BL.X + this.works[index].MatchCoordinates.BR.X) / 2);
        return Math.round(x);
      },

      ariaLabelForWork(index) {
        var title = this.works[index].Title;
        var div = document.createElement("div");
        div.innerHTML = title;
        return `Identified work ${div.innerText}`;
      }
    }
  };
</script>

